import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import FunnelLayout from "../FunnelLayout";
import { useFunnelForm } from "../useFunnelForm";
import { updateStep3 } from "../api";

function CheckIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="20 6 9 17 4 12" />
    </svg>
  );
}

function ShieldIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
    </svg>
  );
}

function ShieldCheckIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      <polyline points="9 12 11 14 15 10" />
    </svg>
  );
}

function CalendarIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="16" y1="2" x2="16" y2="6" />
    </svg>
  );
}

function SearchIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="7" />
      <line x1="21" y1="21" x2="16.5" y2="16.5" />
    </svg>
  );
}

function DollarSignIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="2" x2="12" y2="22" />
      <path d="M17 5H9.5a3.5 3.5 0 000 7h5a3.5 3.5 0 010 7H6" />
    </svg>
  );
}

function HospitalIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M3 21h18" />
      <path d="M5 21V7l7-4 7 4v14" />
      <line x1="12" y1="9" x2="12" y2="15" />
      <line x1="9" y1="12" x2="15" y2="12" />
    </svg>
  );
}

function StarIcon({ size = 22 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polygon points="12 2 15.1 8.5 22 9.5 17 14.5 18.2 21.5 12 18.2 5.8 21.5 7 14.5 2 9.5 8.9 8.5 12 2" />
    </svg>
  );
}

function CurvedArrowIcon() {
  return (
    <svg viewBox="0 0 40 40" width="36" height="36" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M6 6 C 6 22, 14 30, 30 30" />
      <polyline points="24 24 30 30 22 32" />
    </svg>
  );
}

function ArrowRightIcon() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="5" y1="12" x2="19" y2="12" />
      <polyline points="12 5 19 12 12 19" />
    </svg>
  );
}

function LockIcon() {
  return (
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="11" width="18" height="11" rx="2" />
      <path d="M7 11V7a5 5 0 0110 0v4" />
    </svg>
  );
}

function CheckCircleSolidIcon({ size = 18 }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <polyline points="9 12 11 14 16 9" fill="none" stroke="#ffffff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function OptionCard({ selected, onClick, icon, iconColorClass, label }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={selected ? "fv2-step3-option fv2-selected" : "fv2-step3-option"}
      aria-pressed={selected}
    >
      <span className={`fv2-step3-option-icon ${iconColorClass}`}>{icon}</span>
      <span className="fv2-step3-option-label">{label}</span>
      {selected && (
        <span className="fv2-step3-option-check">
          <CheckCircleSolidIcon />
        </span>
      )}
    </button>
  );
}

const INSURERS = [
  "Aetna",
  "Anthem / Blue Cross Blue Shield",
  "Cigna",
  "Humana",
  "Kaiser Permanente",
  "UnitedHealthcare",
  "Molina Healthcare",
  "Oscar",
  "First Health PPO",
  "Multiplan PPO",
  "COBRA",
  "Other",
  "I'd rather not say"
];

export default function Step3() {
  const navigate = useNavigate();
  const { data, update } = useFunnelForm();

  const [hasInsurance, setHasInsurance] = useState(data.step3?.hasInsurance || "");
  const [currentInsurer, setCurrentInsurer] = useState(data.step3?.currentInsurer || "");
  const [timing, setTiming] = useState(data.step3?.timing || "");
  const [priority, setPriority] = useState(data.step3?.priority || "");
  const [errors, setErrors] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const [apiError, setApiError] = useState("");

  const clearError = (key) => {
    setErrors((prev) => {
      if (!prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const handleInsuranceChange = (val) => {
    setHasInsurance(val);
    clearError("hasInsurance");
    if (val === "no") {
      setCurrentInsurer("");
      clearError("currentInsurer");
    }
  };

  const handleInsurerChange = (val) => {
    setCurrentInsurer(val);
    clearError("currentInsurer");
  };

  const handleTimingChange = (val) => {
    setTiming(val);
    clearError("timing");
  };

  const handlePriorityChange = (val) => {
    setPriority(val);
    clearError("priority");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const next = {};
    if (!hasInsurance) next.hasInsurance = "Please choose an option.";
    if (hasInsurance === "yes" && !currentInsurer) {
      next.currentInsurer = "Please select your current insurance provider.";
    }
    if (!timing) next.timing = "Please choose when you want coverage to start.";
    if (!priority) next.priority = "Please choose what matters most to you.";

    setErrors(next);

    if (Object.keys(next).length > 0) {
      const order = ["hasInsurance", "currentInsurer", "timing", "priority"];
      const firstKey = order.find((k) => next[k]);
      if (firstKey) {
        const el = document.getElementById(`fv2-q-${firstKey}`);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }
      return;
    }

    if (submitting) return;

    const step3 = {
      hasInsurance,
      currentInsurer: hasInsurance === "yes" ? currentInsurer : "",
      timing,
      priority
    };
    update("step3", step3);

    if (!data.leadId) {
      navigate("/v2/step-1");
      return;
    }

    setApiError("");
    setSubmitting(true);
    try {
      await updateStep3(data.leadId, {
        step1: data.step1,
        step2: data.step2,
        step3,
        createdAt: data.createdAt,
        tracking: data.tracking,
        pageUrl: window.location.href
      });
      navigate("/v2/step-4");
    } catch (err) {
      setApiError("We couldn't save your info. Please try again.");
      setSubmitting(false);
    }
  };

  return (
    <FunnelLayout currentStep={3}>
      <div className="fv2-step3">
        <h1 className="fv2-step3-h1">
          <span className="fv2-step3-h1-line">Help Us Match You</span>
          <span className="fv2-step3-h1-line">With The Right Options</span>
        </h1>
        <p className="fv2-step3-sub">
          A few quick questions help us narrow down the best plans for your
          needs and budget.
        </p>

        <form onSubmit={handleSubmit} noValidate>
          <div id="fv2-q-hasInsurance" className="fv2-step3-q">
            <div className="fv2-step3-q-head">
              <span className="fv2-step3-q-badge" aria-hidden="true">1</span>
              <h3 className="fv2-step3-q-text">
                Do you currently have health insurance?
              </h3>
            </div>
            <div className="fv2-step3-options fv2-step3-options-2">
              <OptionCard
                selected={hasInsurance === "yes"}
                onClick={() => handleInsuranceChange("yes")}
                icon={<CheckIcon />}
                iconColorClass="fv2-step3-icon-green"
                label="Yes, I have coverage"
              />
              <OptionCard
                selected={hasInsurance === "no"}
                onClick={() => handleInsuranceChange("no")}
                icon={<ShieldIcon />}
                iconColorClass="fv2-step3-icon-blue-dark"
                label="No, I need coverage"
              />
            </div>
            {errors.hasInsurance && (
              <p className="fv2-step3-q-error" role="alert">
                {errors.hasInsurance}
              </p>
            )}
          </div>

          <div
            className={
              hasInsurance === "yes"
                ? "fv2-step3-q1a-wrapper fv2-step3-q1a-open"
                : "fv2-step3-q1a-wrapper"
            }
            aria-hidden={hasInsurance !== "yes"}
          >
            <div className="fv2-step3-q1a-inner">
              <div id="fv2-q-currentInsurer" className="fv2-step3-q1a">
                <div className="fv2-step3-q1a-arrow" aria-hidden="true">
                  <CurvedArrowIcon />
                </div>
                <div className="fv2-step3-q1a-card">
                  <div className="fv2-step3-q-head">
                    <span className="fv2-step3-q-badge" aria-hidden="true">1a</span>
                    <h3 className="fv2-step3-q-text">
                      Who are you currently insured with?
                    </h3>
                  </div>
                  <select
                    className={
                      "fv2-step3-select" +
                      (currentInsurer === "" ? " fv2-step3-select-empty" : "") +
                      (errors.currentInsurer ? " fv2-step3-select-error" : "")
                    }
                    value={currentInsurer}
                    onChange={(e) => handleInsurerChange(e.target.value)}
                    aria-label="Current insurance provider"
                  >
                    <option value="" disabled hidden>
                      Select your current insurance provider
                    </option>
                    {INSURERS.map((name) => (
                      <option key={name} value={name}>
                        {name}
                      </option>
                    ))}
                  </select>
                  <p className="fv2-step3-q1a-helper">
                    <span className="fv2-step3-q1a-helper-icon">
                      <ShieldIcon size={14} />
                    </span>
                    This helps us understand your current coverage.
                  </p>
                  {errors.currentInsurer && (
                    <p className="fv2-step3-q-error" role="alert">
                      {errors.currentInsurer}
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div id="fv2-q-timing" className="fv2-step3-q">
            <div className="fv2-step3-q-head">
              <span className="fv2-step3-q-badge" aria-hidden="true">2</span>
              <h3 className="fv2-step3-q-text">
                When do you want coverage to start?
              </h3>
            </div>
            <div className="fv2-step3-options fv2-step3-options-3">
              <OptionCard
                selected={timing === "asap"}
                onClick={() => handleTimingChange("asap")}
                icon={<CalendarIcon />}
                iconColorClass="fv2-step3-icon-green"
                label="As soon as possible"
              />
              <OptionCard
                selected={timing === "30days"}
                onClick={() => handleTimingChange("30days")}
                icon={<CalendarIcon />}
                iconColorClass="fv2-step3-icon-blue"
                label="Within 30 days"
              />
              <OptionCard
                selected={timing === "exploring"}
                onClick={() => handleTimingChange("exploring")}
                icon={<SearchIcon />}
                iconColorClass="fv2-step3-icon-muted"
                label="Just exploring"
              />
            </div>
            {errors.timing && (
              <p className="fv2-step3-q-error" role="alert">
                {errors.timing}
              </p>
            )}
          </div>

          <div id="fv2-q-priority" className="fv2-step3-q">
            <div className="fv2-step3-q-head">
              <span className="fv2-step3-q-badge" aria-hidden="true">3</span>
              <h3 className="fv2-step3-q-text">What matters most to you?</h3>
            </div>
            <div className="fv2-step3-options fv2-step3-options-4">
              <OptionCard
                selected={priority === "cost"}
                onClick={() => handlePriorityChange("cost")}
                icon={<DollarSignIcon />}
                iconColorClass="fv2-step3-icon-green"
                label="Lower monthly cost"
              />
              <OptionCard
                selected={priority === "coverage"}
                onClick={() => handlePriorityChange("coverage")}
                icon={<ShieldIcon />}
                iconColorClass="fv2-step3-icon-blue"
                label="More coverage"
              />
              <OptionCard
                selected={priority === "providers"}
                onClick={() => handlePriorityChange("providers")}
                icon={<HospitalIcon />}
                iconColorClass="fv2-step3-icon-purple"
                label="Top doctors & hospitals"
              />
              <OptionCard
                selected={priority === "all"}
                onClick={() => handlePriorityChange("all")}
                icon={<StarIcon />}
                iconColorClass="fv2-step3-icon-orange"
                label="All of the above"
              />
            </div>
            {errors.priority && (
              <p className="fv2-step3-q-error" role="alert">
                {errors.priority}
              </p>
            )}
          </div>

          <div className="fv2-step3-reassure">
            <span className="fv2-step3-reassure-icon">
              <ShieldCheckIcon size={22} />
            </span>
            <div className="fv2-step3-reassure-text">
              <strong>We find options. You choose what's best.</strong>
              <p>
                Your answers help us show accurate plan options available in
                your area.
              </p>
            </div>
          </div>

          <button type="submit" className="fv2-step3-submit" disabled={submitting}>
            {submitting ? "Saving..." : "Continue"}
            <ArrowRightIcon />
          </button>

          {apiError && (
            <p className="fv2-step3-q-error" role="alert">{apiError}</p>
          )}

          <p className="fv2-step3-secure">
            <LockIcon /> Your information is secure and confidential.
          </p>
        </form>
      </div>
    </FunnelLayout>
  );
}
